@if (loaded) {
  <div id="links" class="card shadow border-0 mb-3 tab-pane fade fade-in-zoom active show" role="tabpanel">
    <div class="card-header fw-bold bg-tertiary p-3 border-0 d-flex justify-content-between align-items-center">
      <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-link-45deg me-2 text-primary"></i>Links</h2>
    </div>
    <div class="card-body">
      <div class="d-flex flex-wrap gap-3">
        @for (p of products; track p) {
          <div class="text-center">
            <input type="radio" id="product-{{ p.id }}" name="productId" class="btn-check" autocomplete="off"
                   [value]="p" [(ngModel)]="product" (change)="productChanged()">
            <label for="product-{{ p.id }}" class="brand-label">
              @if (p?.logo) {
                <img [ngSrc]="imageService.getImageUrl($safeNavigationMigration(p?.logo), 348, 174)" alt=""
                     class="img-fluid brand-image rounded border border-warning border-3" width="174" height="87"
                     priority>
              }
              <p class="mt-2 small">{{ p.name }}</p>
            </label>
          </div>
        }
      </div>
      <div class="bg-tertiary p-2 border-start border-warning border-5 mb-3">
        <h3 class="fw-bold fs-6 mb-0">Tracking</h3>
      </div>
      <div class="row g-3 ng-submitted">
        <div class="col-12">
          <label for="trackingDomain" class="form-label">
            Tracking Domain
          </label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-globe"></i></span>
            <select id="trackingDomain" class="form-select" [(ngModel)]="trackingDomain"
                    [appElementLoader]="trackingDomainsLoading">
              @for (trackingDomain of trackingDomains; track trackingDomain) {
                <option
                  [ngValue]="trackingDomain">{{ trackingDomain }}
                </option>
              }
            </select>
            <a (click)="createTrackingDomain()" class="btn btn-outline-primary btn-sm d-flex align-items-center"><i
              class="bi bi-plus-circle me-2"></i> Add</a>
            <a (click)="modifyTrackingDomain()" class="btn btn-outline-primary btn-sm d-flex align-items-center"><i
              class="bi bi-pencil me-2"></i> Edit</a>
          </div>
          <!--          <div class="modal fade" id="editDomainModal" tabindex="-1" aria-labelledby="editDomainModalLabel"-->
          <!--               style="display: none;" aria-hidden="true">-->
          <!--            <div class="modal-dialog modal-dialog-centered">-->
          <!--              <div class="modal-content">-->
          <!--                <div class="modal-header bg-tertiary">-->
          <!--                  <h6 class="modal-title fw-bold" id="editDomainModalLabel">Edit Domain</h6>-->
          <!--                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>-->
          <!--                </div>-->
          <!--                <div class="modal-body">-->
          <!--                  <label for="editDomainInput" class="form-label">Domain Name</label>-->
          <!--                  <input type="text" id="editDomainInput" class="form-control" value="domain1">-->
          <!--                </div>-->
          <!--                <div class="modal-footer">-->
          <!--                  <button type="button" class="btn btn-outline-primary fw-bold" data-bs-dismiss="modal">Cancel</button>-->
          <!--                  <button type="button" class="btn btn-primary fw-bold">Save</button>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
        <div class="col-12">
          <div class="row g-3">
            <div class="col">
              <label for="subid" class="form-label">SubID</label>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-filter"></i></span>
                <input id="subid" type="text" class="form-control" [(ngModel)]="options.subid"
                       [disabled]="isAdvertiser()">
              </div>
            </div>
            <div class="col">
              <label for="tc1" class="form-label">Tracker 1</label>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-filter"></i></span>
                <input id="tc1" type="text" class="form-control" [(ngModel)]="options.tc1"
                       [disabled]="isAdvertiser()">
              </div>
            </div>
            <div class="col">
              <label for="tc2" class="form-label">Tracker 2</label>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-filter"></i></span>
                <input id="tc2" type="text" class="form-control" [(ngModel)]="options.tc2"
                       [disabled]="isAdvertiser()">
              </div>
            </div>
            <div class="col">
              <label for="tc3" class="form-label">Tracker 3</label>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-filter"></i></span>
                <input id="tc3" type="text" class="form-control" [(ngModel)]="options.tc3"
                       [disabled]="isAdvertiser()">
              </div>
            </div>
            <div class="col">
              <label for="tc4" class="form-label">Tracker 4</label>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-filter"></i></span>
                <input id="tc4" type="text" class="form-control" [(ngModel)]="options.tc4"
                       [disabled]="isAdvertiser()">
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row g-3">
            @if (!isAdvertiser()) {
              <div class="col-3">
                <label for="clickid" class="form-label">ClickID</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-mouse"></i></span>
                  <input type="text" id="clickid" class="form-control" [(ngModel)]="options.clickid">
                </div>
              </div>
              <div class="col-3">
                <label for="gclid" class="form-label">GCLID</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-google"></i></span>
                  <input type="text" id="gclid" class="form-control" [(ngModel)]="options.gclid">
                </div>
              </div>
              <div class="col-3">
                <label for="fbclid" class="form-label">FBCLID</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-facebook"></i></span>
                  <input type="text" id="fbclid" class="form-control" [(ngModel)]="options.fbclid">
                </div>
              </div>
              <div class="col-3">
                <label for="fbclid" class="form-label">TWCLID</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-twitter-x"></i></span>
                  <input type="text" id="twclid" class="form-control" [(ngModel)]="options.twclid">
                </div>
              </div>
              <div class="col-3">
                <label for="fbclid" class="form-label">TTCLID</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-tiktok"></i></span>
                  <input type="text" id="ttclid" class="form-control" [(ngModel)]="options.ttclid">
                </div>
              </div>
            }
            @if (isMetaAdvertiser()) {
              <div class="col-3">
                <label for="fbpxid" class="form-label">FB Pixel ID</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-bar-chart"></i></span>
                  <input type="text" id="fbpxid" class="form-control" [(ngModel)]="options.fbpxid"
                         [required]="isMetaAdvertiser()">
                </div>
              </div>
            }
            @if (isMicrosoftAdvertiser()) {
              <div class="col-3">
                <label for="mspxid" class="form-label">MS Pixel ID</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-bar-chart"></i></span>
                  <input type="text" id="mspxid" class="form-control" [(ngModel)]="options.mspxid"
                         [required]="isMicrosoftAdvertiser()">
                </div>
              </div>
            }
            @if (isXAdvertiser()) {
              <div class="col-3">
                <label for="twpxid" class="form-label">X Pixel ID</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-bar-chart"></i></span>
                  <input type="text" id="twpxid" class="form-control" [(ngModel)]="options.twpxid"
                         [required]="isXAdvertiser()">
                </div>
              </div>
            }
            @if (isTiktokAdvertiser()) {
              <div class="col-3">
                <label for="mspxid" class="form-label">Tiktok Pixel ID</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="bi bi-bar-chart"></i></span>
                  <input type="text" id="ttpxid" class="form-control" [(ngModel)]="options.ttpxid"
                         [required]="isTiktokAdvertiser()">
                </div>
              </div>
            }
            <div class="col-3">
              <label for="source" class="form-label">Source</label>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-box-arrow-in-right"></i></span>
                <select id="source" class="form-select" [(ngModel)]="options.source" (change)="refreshTracker()">
                  @for (trafficSource of trafficSources; track trafficSource) {
                    <option [ngValue]="trafficSource.key"
                    >{{ trafficSource.name }}
                    </option>
                  }
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-tertiary p-2 border-start border-warning border-5 mb-3 mt-3">
        <h3 class="fw-bold fs-6 mb-0">Destination</h3>
      </div>
      <div class="row g-3">
        @if (partner?.isAffiliate()) {
          <div class="col-6">
            <label for="conversionType" class="form-label">Conversion type</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-cash-stack"></i></span>
              <select id="conversionType" class="form-select" [(ngModel)]="conversionType"
                      (change)="conversionTypeChanged()">
                <option [ngValue]="null" disabled>Select conversion type</option>
                @for (conversionType of conversionTypeList; track conversionType) {
                  <option
                    [ngValue]="conversionType">{{ ('conversionType.' + conversionType) | translate }}
                  </option>
                }
              </select>
            </div>
          </div>
        }
        <div class="col-6">
          <label for="offer" class="form-label">Offer</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-gift"></i></span>
            <select id="offer" class="form-select" [(ngModel)]="offer" [disabled]="isOfferDisabled()"
                    (change)="offerChanged()">
              <option value="" disabled [text]="getOfferDefaultText()"></option>
              @for (offer of offers; track offer) {
                <option [ngValue]="offer">{{ offer }}</option>
              }
            </select>
          </div>
        </div>
        <div class="col-3">
          <label for="pageType" class="form-label">Type</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-box-arrow-in-right"></i></span>
            <select id="pageType" class="form-select" [(ngModel)]="pageType" (change)="pageTypeChanged()">
              <option [ngValue]="null" disabled>Select a type</option>
              @for (pageType of pageTypes; track pageType) {
                <option [ngValue]="pageType.id">{{ pageType }}</option>
              }
            </select>
          </div>
        </div>
        @if (pageType) {
          <div class="col-3 d-flex align-items-end py-1 justify-content-center">
            <div class="form-check">
              <input class="form-check-input" type="radio" name="linkTypeLandingPage" id="linkTypeLandingPage"
                     [(ngModel)]="linkType" value="lp" (ngModelChange)="linkTypeChanged()">
              <label class="form-check-label" for="linkTypeLandingPage">
                Promotion link
              </label>
            </div>
            <div class="form-check ms-5">
              <input class="form-check-input" type="radio" name="linkTypePool" id="linkTypePool" [(ngModel)]="linkType"
                     value="pool" (ngModelChange)="linkTypeChanged()">
              <label class="form-check-label" for="linkTypePool">
                Pool
              </label>
            </div>
          </div>
          @if (linkType === 'pool') {
            <div class="col-6">
              <label for="pool" class="form-label">Pool</label>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-box-arrow-in-right"></i></span>
                <select id="pool" class="form-select" [(ngModel)]="pool" [disabled]="isPoolDisabled()"
                        (change)="poolChanged()">
                  <option [ngValue]="null" [text]="getPoolDefaultText()" disabled></option>
                  @for (pool of pools; track pool) {
                    <option [ngValue]="pool">{{ pool }}</option>
                  }
                </select>
              </div>
            </div>
          }
          @if (linkType === 'lp') {
            <div class="col-6">
              <label for="destination" class="form-label">Promotion link</label>
              <div class="input-group">
                <span class="input-group-text"><i class="bi bi-map"></i></span>
                <select id="destination" class="form-select" [(ngModel)]="landingPage"
                        [disabled]="isLandingPageDisabled()"
                        (change)="landingPageChanged()">
                  <option [ngValue]="null" [text]="getLandingPageDefaultText()" disabled></option>
                  @for (landingPage of landingPages; track landingPage) {
                    <option [ngValue]="landingPage">{{ landingPage.name }}
                    </option>
                  }
                </select>
              </div>
            </div>
          }
        }
        @if (isPromotionLinkValid()) {
          <div class="col-12">
            <div class="bg-tertiary p-2 border-start border-warning border-5 mb-3">
              <h3 class="fw-bold fs-6 mb-0">Promotion adserver link</h3>
            </div>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
              <input type="text" id="promotionLink" class="form-control" readonly="" [value]="getLink()">
              <button type="button" class="btn btn-primary fw-bold" (click)="copyUrl(getLink())">
                @if (!copied) {
                  <span>Copy</span>
                }
                @if (copied) {
                  <span class="text-nowrap"><i class="fas fa-copy"></i> Copied !</span>
                }
              </button>
              <a class="btn btn-primary fw-bold" [href]="getLink()" target="_blank">Open link</a>
            </div>
          </div>
        }
        @if (isPromotionDirectLinkValid()) {
          <div class="col-12">
            <div class="bg-tertiary p-2 border-start border-warning border-5 mb-3">
              <h3 class="fw-bold fs-6 mb-0">Promotion direct link</h3>
            </div>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
              <input type="text" id="promotionDirectLink" class="form-control" readonly="" [value]="getDirectLink()">
              <button type="button" class="btn btn-primary fw-bold" (click)="copyUrl(getDirectLink())">
                @if (!copied) {
                  <span>Copy</span>
                }
                @if (copied) {
                  <span class="text-nowrap"><i class="fas fa-copy"></i> Copied !</span>
                }
              </button>
              <a class="btn btn-primary fw-bold" [href]="getDirectLink()" target="_blank">Open link</a>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
